export type ConsentEntityType =
  | "template"
  | "classic_quiz"
  | "personality_quiz"
  | "either_or"
  | "match_quiz"
  | "top_x"
  | "bracket"
  | "standing"
  | "poll"
  | "bracket"
  | "standing";

export default class ConsentRequestBody {
  public consentId: string = "";
  public entityId?: string | null = null;
  public entityType?: ConsentEntityType | null = null;
  public content?: string | null = null;
}
